import { permit } from '@lba-dev/package.local-globals/restrictions';

import store from '../store';

export const aVerifierPoint = (user, points) => {
  const state = store.getState();
  user = user || state.connectedUser;
  points = points || state.points;
  const point = points.find((e) => e._id === user._id);
  return {
    point: Math.trunc(
      point && point.totalDifference ? point.totalDifference : 0
    ),
    condition:
      user.maxV &&
      point &&
      point.totalDifference >= user.maxV &&
      !permit(user, { key: 'addIntervention' }),
    maxV: user.maxV,
  };
};
